import o from "../../../node_modules/classnames/index.js";
import "./selectCard2.js";
import { jsx as a } from "../../../_virtual/jsx-runtime.js";
function m({
  onSelect: c,
  className: l,
  options: r,
  visible: e
}) {
  return /* @__PURE__ */ a("div", {
    className: o("select-card", l),
    "data-visible": e,
    children: /* @__PURE__ */ a("div", {
      className: "select-card__box",
      tabIndex: -1,
      children: r.map((t) => /* @__PURE__ */ a("button", {
        tabIndex: e ? 0 : -1,
        onClick: (i) => {
          i.stopPropagation(), c(t.value);
        },
        type: "button",
        className: "select-card__item",
        children: t.label
      }, JSON.stringify(t)))
    })
  });
}
export {
  m as SelectCard
};
//# sourceMappingURL=SelectCard.js.map
